import $ from 'jquery'

const scrollableClass = 'dhsv_vc_video_teaser_slider--scrollable'

function getSlides(track) {
  return Array.from(track.children).filter(child =>
    child.classList.contains('dhsv_vc_video_teaser')
  )
}

function getStep(track) {
  const slides = getSlides(track)
  if (slides.length > 1) {
    return slides[1].offsetLeft - slides[0].offsetLeft
  }
  return track.clientWidth
}

function initVideoTeaserSlider(slider) {
  const track = slider.querySelector('.js-video-teaser-slider-track')
  const prevButton = slider.querySelector('.js-video-teaser-slider-prev')
  const nextButton = slider.querySelector('.js-video-teaser-slider-next')

  if (!track || !prevButton || !nextButton) {
    return
  }

  const update = () => {
    const maxScroll = track.scrollWidth - track.clientWidth
    // 1px tolerance for sub-pixel scroll positions.
    slider.classList.toggle(scrollableClass, maxScroll > 1)
    prevButton.disabled = track.scrollLeft <= 1
    nextButton.disabled = track.scrollLeft >= maxScroll - 1
  }

  prevButton.addEventListener('click', () => {
    track.scrollBy({ left: -getStep(track), behavior: 'smooth' })
  })

  nextButton.addEventListener('click', () => {
    track.scrollBy({ left: getStep(track), behavior: 'smooth' })
  })

  track.addEventListener('scroll', update, { passive: true })
  $(window).on('resize', update)
  update()
}

$(document).ready(function () {
  document
    .querySelectorAll('.js-video-teaser-slider')
    .forEach(initVideoTeaserSlider)
})
